import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth';

const routes: Routes = [
  {
    path: 'sign-in',
    loadChildren: () => import('./pages/sign-in').then((m) => m.SignInModule),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/sidenav').then((m) => m.SidenavModule),
      },
      {
        path: '**',
        loadChildren: () => import('./pages/not-found').then((m) => m.NotFoundModule),
      },
    ],
  },
  {
    path: '**',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/not-found').then((m) => m.NotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
